import { Api } from './Api';
import { ApiActor } from './ApiActor';
import { App } from '../app/App';
import { createUseApiAtom } from './useApiAtom';
import { GetEndpointMethodNames } from './GetEndpointMethodNames';
import React from 'react';

export type GetUseSharedApi<TApi extends Api<any, any>> = <
  TPath extends TApi['Path'],
  TMethod extends GetEndpointMethodNames<TApi, TPath>,
>(
  path: TPath,
  method: TMethod,
  key?: string,
) => ApiActor<TApi, TPath, TMethod>;

export const createUseSharedApi = <TApp extends App<any, any>>(app: TApp) => {
  const useApiAtom = createUseApiAtom(app);

  return function useSharedApi<
    TPath extends TApp['_Api']['Path'],
    TMethod extends GetEndpointMethodNames<TApp['_Api'], TPath>,
  >(
    path: TPath,
    method: TMethod,
    key?: string,
  ): ApiActor<TApp['_Api'], TPath, TMethod> {
    const atom = useApiAtom(path, method, key);
    const isLoggedAndAgeDefined =
      sessionStorage.getItem('token') &&
      window.location.pathname !== '/first-loan/personal-data';

    const apiActor = React.useMemo(
      () =>
        ({
          ...atom,
          isLoaded: atom.data !== undefined,
        } as ApiActor<TApp['_Api'], TPath, TMethod>),
      [atom, isLoggedAndAgeDefined],
    );

    return apiActor;
  };
};
